export default {
  root: {
    backgroundColor: '#FFFFFF',
    color: '#66788A',
    '&:hover': {
      backgroundColor: '#E4E7EB'
    }
  }
};
